import { useState } from "react"

import { Icon } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import { TooltipButton } from "components/lib/UI"
import { useAppSelector } from "store"
import util from "utils/utils"

import RequestJoinModal from "../../RequestJoinModal"

type JoinTeamActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
}

const JoinTeamAction = ({ idea }: JoinTeamActionProps) => {
  const [joinModalOpen, setJoinModalOpen] = useState(false)
  const user = useAppSelector((state) => state.user)

  if (!user || !idea) {
    return null
  }

  if (util.canEditIdea(user, idea)) {
    return null
  }

  if (idea?.ownerChallenge?.preventCollaboration) {
    return null
  }

  return (
    <>
      <RequestJoinModal
        idea={idea}
        open={joinModalOpen}
        onClose={() => setJoinModalOpen(false)}
        onConfirm={() => {
          util.onUpdateIdea(idea, { requestedToJoin: true })
        }}
      />
      <TooltipButton
        secondary={idea.requestedToJoin}
        disabled={idea.requestedToJoin}
        onClick={() => {
          setJoinModalOpen(true)
        }}
        icon
        tooltip={idea.requestedToJoin ? "Awaiting approval to join" : "Join team"}
      >
        <Icon name="users" />
      </TooltipButton>
    </>
  )
}

export default JoinTeamAction
